/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Music, Film, Tv, ChevronLeft, ChevronRight } from "lucide-react";
import MobileTitleSpacer from "../components/MobileTitleSpacer";
import { useAudio } from "../context/AudioContext";
import SEO from '../components/SEO';
import { seoConfig } from '../utils/seoConfig';

const SPOTIFY_IFRAME_API_SRC = "https://open.spotify.com/embed/iframe-api/v1";
const YT_IFRAME_API_SRC = "https://www.youtube.com/iframe_api";
const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

const Musique = () => {
  const projectRefs = useRef({});
  const location = useLocation();
  // CORRECTION : initialiser à false au lieu de undefined
  const [spotifyApiLoaded, setSpotifyApiLoaded] = useState(false);

  const {
    currentPlayer,
    setActivePlayer,
    registerSpotifyController,
    unregisterSpotifyController,
    stopExternalPlayers,
  } = useAudio();

  // mémoires locales
  const ytPlayersRef = useRef({});
  const spotifyControllersRef = useRef({});

  // État uniquement visuel : la logique audio d'origine reste inchangée.
  const [activeIndex, setActiveIndex] = useState(0);
  const [mobilePlayerOpen, setMobilePlayerOpen] = useState(false);
  const touchStartRef = useRef(null);
  const swipeLockedRef = useRef(false);
  const cardRefs = useRef([]);
  const trackpadAccumRef = useRef(0);
  const trackpadResetTimerRef = useRef(null);
  const trackpadLockedRef = useRef(false);

  const projects = [
    {
      id: "UNE AUTRE PLANÈTE - INSTRUMENTALES",
      smartlink: "https://ffm.to/une-autre-planete-instrumentales",
      title: "",
      type: "ALBUM",
      year: "2026",
      icon: Music,
      image: "/images/une_autre_planete_instrumentales_2026.jpg",
      spotifyUrl:
        "https://open.spotify.com/embed/album/4sKToUJKKBSXRIFlHTSxle?utm_source=generator",
      description: "",
    },
    {
      id: "UNE NUIT INFINIE - INSTRUMENTALES",
      smartlink: "https://ffm.to/une-nuit-infinie-instrumentales",
      title: "",
      type: "ALBUM",
      year: "2026",
      icon: Music,
      image: "/images/une_nuit_infinie_instrumentales_2026.png",
      spotifyUrl:
        "https://open.spotify.com/embed/album/5qPcPV8GKCas6lqo2xzs63?utm_source=generator",
      description: "",
    },
    {
      id: "UNE AUTRE PLANÈTE",
      smartlink: "https://ffm.to/une-autre-planete",
      title: "",
      type: "ALBUM",
      year: "2026",
      icon: Music,
      image: "/images/une_autre_planete_2026.png",
      spotifyUrl:
        "https://open.spotify.com/embed/album/2yvotHeYGp86UTQQaW7GX6?utm_source=generator",
      description: "",
    },
    {
      id: "La-Sympathie",
      smartlink: "https://ffm.to/evyxe8k",
      title: "",
      type: "EP",
      year: "2026",
      icon: Music,
      image: "/images/LA SYMPATHIE.png",
      spotifyUrl:
        "https://open.spotify.com/embed/album/6UVJIVcHefhOvg4riyKnW2?utm_source=generator",
      description: "",
    },
    {
      id: "une-nuit-infinie",
      smartlink: "https://ffm.to/unenuitinfinie",
      title: "",
      type: "Album Original",
      year: "2025",
      icon: Music,
      image: "/images/une_nuit_infinie.jpg",
      spotifyUrl:
        "https://open.spotify.com/embed/album/32Nq0PqvHSna7KiERynrIK?utm_source=generator",
      description: "",
    },
    {
      id: "bonne-conduite",
      smartlink: "https://ffm.to/bonneconduite",
      title: "",
      type: "Bande Originale Film",
      year: "2023",
      icon: Film,
      image: "/images/bonne-conduite.jpg",
      spotifyUrl:
        "https://open.spotify.com/embed/album/1ppGgR3cCSvEvO6p5F8p5M?utm_source=generator",
      description: "Réalisateur : Jonathan Barré",
    },
    {
      id: "les-vedettes",
      smartlink: "https://ffm.to/lesvedettes",
      title: "",
      type: "Bande Originale Film",
      year: "2021",
      icon: Film,
      image: "/images/les_vedettes.jpg",
      spotifyUrl:
        "https://open.spotify.com/embed/album/4hJoNiCzMMixBYefbAY0CF?utm_source=generator",
      description: "Réalisateur : Jonathan Barré",
    },
    {
      id: "max-et-leon",
      title: "",
      type: "Bande Originale Film",
      year: "2016",
      icon: Film,
      image: "/images/Max_et_leon.jpg",
      youtubeUrl:
        "https://www.youtube.com/embed/videoseries?si=Cls7LU9vhgykaORh&list=PLSZG5UFmFKezGjNhl8Pn7B7TaCJnXGqYW",
      description: "Réalisateur : Jonathan Barré",
    },
    {
      id: "palmashow",
      smartlink: "https://ffm.to/palmashowalbum",
      title: "",
      type: "Musiques Série TV",
      year: "2012-2023",
      icon: Tv,
      image: "/images/palmashow_cover.jpg",
      spotifyUrl:
        "https://open.spotify.com/embed/album/2Ts1aTmF5gJbrMto1jTLDF?utm_source=generator",
      description: "",
    },
  ];

  const ytWithApi = (url) => {
    if (!url) return "";
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}enablejsapi=1&origin=${encodeURIComponent(
      ORIGIN
    )}&modestbranding=1&rel=0`;
  };

  const spotifyEmbedUrlToUri = (embedUrl) => {
    try {
      const u = new URL(embedUrl);
      const path = u.pathname;
      const id = path.split("/").pop();
      const t =
        path.includes("/album/") ? "album" :
        path.includes("/playlist/") ? "playlist" :
        path.includes("/track/") ? "track" :
        null;
      return t && id ? `spotify:${t}:${id}` : null;
    } catch {
      return null;
    }
  };

  const pauseAllSpotifyControllers = (exceptId = null) => {
    const pauseOthers = () => {
      try {
        const map = spotifyControllersRef.current || {};
        Object.entries(map).forEach(([id, ctrl]) => {
          if (exceptId && id === exceptId) return;
          try { ctrl?.pause?.(); } catch {}
        });
      } catch {}
    };

    // Spotify peut signaler le démarrage avant qu'un ancien contrôleur ait
    // complètement changé d'état. On répète la pause brièvement pour éviter
    // que deux embeds restent audibles en même temps.
    pauseOthers();
    window.setTimeout(pauseOthers, 90);
    window.setTimeout(pauseOthers, 240);
  };

  useEffect(() => {
    const target =
      location.state?.scrollTo || window.location.hash.replace("#", "");

    if (!target) return;

    const targetIndex = projects.findIndex((project) => project.id === target);
    if (targetIndex < 0) return;

    setActiveIndex(targetIndex);

    const t = window.setTimeout(() => {
      const el = cardRefs.current[targetIndex];
      el?.scrollIntoView?.({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }, 180);

    return () => window.clearTimeout(t);
  }, [location.state, location.hash]);

  // Spotify IFrame API : robuste aux navigations internes React.
  // Si le script est déjà chargé, on recrée immédiatement les contrôleurs.
  // S'il est seulement présent mais pas encore prêt, on attend son callback.
  useEffect(() => {
    let disposed = false;
    let initialized = false;

    const initSpotifyControllers = (IFrameAPI) => {
      if (disposed || initialized || !IFrameAPI) return;
      initialized = true;

      window.IFrameAPI = IFrameAPI;
      setSpotifyApiLoaded(true);

      window.setTimeout(() => {
        if (disposed) return;

        projects.forEach((p) => {
          if (!p.spotifyUrl) return;

          const uri = spotifyEmbedUrlToUri(p.spotifyUrl);
          if (!uri) return;

          const mounts = [
            { key: p.id, el: document.getElementById(`spotify-embed-${p.id}`) },
            { key: `${p.id}-mobile`, el: document.getElementById(`spotify-embed-mobile-${p.id}`) },
          ].filter((item) => item.el);

          mounts.forEach(({ key, el }) => {
            try {
              IFrameAPI.createController(
                el,
                { uri, width: "100%", height: 352 },
                (EmbedController) => {
                  if (disposed) return;

                  registerSpotifyController(key, EmbedController);
                  spotifyControllersRef.current[key] = EmbedController;

                  EmbedController.addListener("playback_update", (e) => {
                    if (e?.data && e.data.isPaused === false) {
                      pauseAllSpotifyControllers(key);
                      setActivePlayer("external");
                    }
                  });

                  EmbedController.addListener("playback_started", () => {
                    pauseAllSpotifyControllers(key);

                    try {
                      Object.values(ytPlayersRef.current || {}).forEach(
                        (player) => player?.pauseVideo?.()
                      );
                    } catch {}

                    setActivePlayer("external");
                  });
                }
              );
            } catch (error) {
              console.error(`Erreur controller Spotify ${key}:`, error);
            }
          });
        });
      }, 250);
    };

    const spotifyReadyHandler = (IFrameAPI) => {
      initSpotifyControllers(IFrameAPI);
    };

    // Toujours remplacer le callback par celui du composant actuellement monté.
    window.onSpotifyIframeApiReady = spotifyReadyHandler;

    // Cas important : retour sur /musique après une autre page.
    // L'API a déjà été chargée et le callback global ne sera pas rappelé.
    if (window.IFrameAPI) {
      initSpotifyControllers(window.IFrameAPI);
    } else {
      const existingScript = document.querySelector(
        `script[src="${SPOTIFY_IFRAME_API_SRC}"]`
      );

      if (!existingScript) {
        const script = document.createElement("script");
        script.src = SPOTIFY_IFRAME_API_SRC;
        script.async = true;
        script.onerror = () => {
          if (!disposed) {
            setSpotifyApiLoaded(false);
            console.log("Erreur chargement Spotify API");
          }
        };
        document.body.appendChild(script);
      }
      // Si le script existe déjà mais n'est pas encore prêt, le callback
      // window.onSpotifyIframeApiReady ci-dessus prendra le relais.
    }

    return () => {
      disposed = true;

      projects.forEach((p) => {
        if (!p.spotifyUrl) return;
        unregisterSpotifyController(p.id);
        unregisterSpotifyController(`${p.id}-mobile`);
        delete spotifyControllersRef.current[p.id];
        delete spotifyControllersRef.current[`${p.id}-mobile`];
      });

      if (window.onSpotifyIframeApiReady === spotifyReadyHandler) {
        window.onSpotifyIframeApiReady = undefined;
      }
    };
  }, []);

  useEffect(() => {
    const ensureYTScript = () => {
      if (window.YT && window.YT.Player) {
        initYTPlayers();
        return;
      }
      if (document.querySelector(`script[src="${YT_IFRAME_API_SRC}"]`)) return;
      const s = document.createElement("script");
      s.src = YT_IFRAME_API_SRC;
      s.async = true;
      document.body.appendChild(s);
    };

    const initYTPlayers = () => {
      projects.forEach((p) => {
        if (!p.youtubeUrl) return;
        const id = `yt-embed-${p.id}`;
        const el = document.getElementById(id);
        if (!el || ytPlayersRef.current[p.id]) return;

        try {
          ytPlayersRef.current[p.id] = new window.YT.Player(id, {
            events: {
              onStateChange: (ev) => {
                if (ev?.data === window.YT.PlayerState.PLAYING) {
                  pauseAllSpotifyControllers();
                  setActivePlayer("external");
                }
              },
            },
          });
        } catch (error) {
          console.error("Erreur init YouTube player:", error);
        }
      });
    };

    const prevReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prevReady === "function") prevReady();
      initYTPlayers();
    };

    ensureYTScript();
    if (window.YT && window.YT.Player) initYTPlayers();
  }, []);

  const handleYouTubePointerDownCapture = () => {
    pauseAllSpotifyControllers();
    setActivePlayer("external");
  };

  const selectMobileAlbum = (index) => {
    setActiveIndex(index);
    setMobilePlayerOpen(true);
  };

  const projectLabel = (project) => {
    const labels = {
      "UNE AUTRE PLANÈTE - INSTRUMENTALES": "UNE AUTRE PLANÈTE",
      "UNE NUIT INFINIE - INSTRUMENTALES": "UNE NUIT INFINIE",
      "UNE AUTRE PLANÈTE": "UNE AUTRE PLANÈTE",
      "La-Sympathie": "LA SYMPATHIE",
      "une-nuit-infinie": "UNE NUIT INFINIE",
      "bonne-conduite": "BONNE CONDUITE",
      "les-vedettes": "LES VEDETTES",
      "max-et-leon": "MAX & LÉON",
      "palmashow": "PALMASHOW",
    };
    return labels[project.id] || project.id;
  };

  const goToAlbum = (direction) => {
    if (swipeLockedRef.current) return;
    swipeLockedRef.current = true;
    setActiveIndex((index) => (index + direction + projects.length) % projects.length);
    window.setTimeout(() => { swipeLockedRef.current = false; }, 320);
  };

  const handleAlbumTouchStart = (event) => {
    if (event.touches.length !== 1) return;
    const touch = event.touches[0];
    touchStartRef.current = { x: touch.clientX, y: touch.clientY };
  };

  const handleAlbumTouchEnd = (event) => {
    const start = touchStartRef.current;
    touchStartRef.current = null;
    if (!start || event.changedTouches.length !== 1) return;
    const touch = event.changedTouches[0];
    const dx = touch.clientX - start.x;
    const dy = touch.clientY - start.y;
    // Geste volontaire uniquement : on évite les petits mouvements diagonaux.
    if (Math.abs(dx) < 96 || Math.abs(dx) <= Math.abs(dy) * 1.45) return;
    goToAlbum(dx < 0 ? 1 : -1);
  };

  const handleAlbumWheel = (event) => {
    const dx = event.deltaX;
    const dy = event.deltaY;

    // On ne capte que les vrais gestes horizontaux du trackpad.
    if (Math.abs(dx) < 3 || Math.abs(dx) <= Math.abs(dy) * 1.15) return;

    event.preventDefault();

    if (trackpadLockedRef.current) return;

    trackpadAccumRef.current += dx;

    if (trackpadResetTimerRef.current) {
      window.clearTimeout(trackpadResetTimerRef.current);
    }
    trackpadResetTimerRef.current = window.setTimeout(() => {
      trackpadAccumRef.current = 0;
    }, 110);

    // Seuil volontaire : un geste ample = un seul album.
    if (Math.abs(trackpadAccumRef.current) >= 45) {
      const direction = trackpadAccumRef.current > 0 ? 1 : -1;
      trackpadAccumRef.current = 0;
      trackpadLockedRef.current = true;
      goToAlbum(direction);
      window.setTimeout(() => {
        trackpadLockedRef.current = false;
      }, 320);
    }
  };

  useEffect(() => {
    const el = cardRefs.current[activeIndex];
    el?.scrollIntoView?.({ behavior: "smooth", block: "nearest", inline: "center" });
  }, [activeIndex]);

  const activeProject = projects[activeIndex];

  return (
    <>
      <SEO 
        title={seoConfig.musique.title}
        description={seoConfig.musique.description}
        keywords={seoConfig.musique.keywords}
        url={seoConfig.musique.url}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="min-h-screen bg-black pt-20 pb-12 sm:pb-16"
      >
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          {/* Header */}
          <div className="relative py-4 md:py-20 overflow-hidden mb-2 md:mb-4">
            <div
              className="absolute inset-0 opacity-30"
              style={{
                background:
                  "radial-gradient(circle at 30% 50%, rgba(255,105,180,.3) 0%, transparent 70%)",
              }}
            />
            <div className="relative z-10">
              <MobileTitleSpacer height="80px" />
              <h1
                className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white tracking-wider mb-3 md:mb-4"
                style={{ color: "#ec4899" }}
              >
                ALBUMS/EP
              </h1>
              <div
                className="h-1 w-32 md:w-40 mb-6"
                style={{
                  background: "linear-gradient(to right, #ec4899, transparent)",
                }}
              />
            </div>
          </div>

          {/* Présentation éditoriale : grande pochette + lecteur + rail */}
          {/* Mobile : mosaïque, puis lecteur en overlay flouté */}
          <div className="lg:hidden max-w-6xl mx-auto" data-page-swipe-lock="true">
            <div className={`relative transition-all duration-300 ${mobilePlayerOpen ? "min-h-[500px]" : ""}`}>
              {/* Mosaïque toujours visible derrière */}
              <div
                className={`grid gap-3 sm:gap-4 mb-6 transition-all duration-300 grid-cols-3 md:grid-cols-4 ${
                  mobilePlayerOpen
                    ? "blur-md scale-[0.98] opacity-30 pointer-events-none select-none"
                    : "opacity-100"
                }`}
                aria-hidden={mobilePlayerOpen}
              >
                {projects.map((project, index) => (
                  <button
                    key={`mobile-grid-${project.id}`}
                    type="button"
                    onClick={() => selectMobileAlbum(index)}
                    className={`rounded-xl overflow-hidden transition-all duration-300 ${
                      index === activeIndex && mobilePlayerOpen
                        ? "scale-[1.04] opacity-100 ring-2 ring-white/80"
                        : "opacity-100"
                    }`}
                    aria-label={`Ouvrir ${projectLabel(project)}`}
                  >
                    <div className="aspect-square bg-zinc-950 flex items-center justify-center overflow-hidden">
                      {project.image && project.image !== "/images/" ? (
                        <img
                          src={project.image}
                          alt={projectLabel(project)}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-zinc-950 to-pink-950/30">
                          <Music className="w-8 h-8 text-pink-400" />
                        </div>
                      )}
                    </div>
                  </button>
                ))}
              </div>

              {!mobilePlayerOpen && currentPlayer === "external" && (
                <div className="flex justify-center -mt-2 mb-4">
                  <button
                    type="button"
                    onClick={stopExternalPlayers}
                    className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-semibold text-black shadow-lg shadow-black/30 hover:bg-gray-200 transition"
                    aria-label="Arrêter la lecture Spotify ou vidéo"
                    title="Stop"
                  >
                    <span className="inline-block w-2.5 h-2.5 rounded-[2px] bg-black" />
                    Stop
                  </button>
                </div>
              )}

              {/* Le lecteur reste monté pour conserver l'initialisation Spotify */}
              <div
                className={`absolute inset-x-0 -top-28 bottom-10 z-20 transition-all duration-300 ${
                  mobilePlayerOpen
                    ? "opacity-100 pointer-events-auto"
                    : "opacity-0 pointer-events-none"
                }`}
                aria-hidden={!mobilePlayerOpen}
                onClick={() => setMobilePlayerOpen(false)}
              >
                <div className="absolute inset-0 rounded-2xl bg-black/45 backdrop-blur-sm" />

                <div
                  className="relative z-10 mx-2 sm:mx-4 mt-2 rounded-2xl border border-white/15 bg-black/85 p-3 sm:p-4 shadow-2xl"
                  onClick={(event) => event.stopPropagation()}
                  onTouchStart={handleAlbumTouchStart}
                  onTouchEnd={handleAlbumTouchEnd}
                >
                  <div className="flex items-center justify-between gap-3 mb-3">
                    <button
                      type="button"
                      onClick={() => setMobilePlayerOpen(false)}
                      className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-3 py-2 text-xs font-medium text-white hover:bg-white/10 transition"
                      aria-label="Revenir aux albums"
                    >
                      <ChevronLeft className="w-4 h-4" />
                      Albums
                    </button>

                    <span className="text-[11px] text-gray-500 -translate-x-3">
                      ← Glissez →
                    </span>
                  </div>

                  <div className="relative rounded-xl overflow-hidden bg-zinc-950">
                    {projects.map((project, index) => {
                      const ytSrc = project.youtubeUrl ? ytWithApi(project.youtubeUrl) : null;
                      const visible = index === activeIndex;

                      return (
                        <div
                          key={`mobile-player-${project.id}`}
                          style={{ display: visible ? "block" : "none" }}
                          aria-hidden={!visible}
                        >
                          {project.spotifyUrl && (
                            <div
                              id={`spotify-embed-mobile-${project.id}`}
                              className="w-full h-[352px]"
                            />
                          )}

                          {ytSrc && (
                            <div onPointerDownCapture={handleYouTubePointerDownCapture}>
                              <iframe
                                id={`yt-embed-mobile-${project.id}`}
                                src={ytSrc}
                                className="w-full h-[280px]"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title={`${projectLabel(project)} - YouTube`}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  <div className="flex flex-wrap items-center justify-between gap-3 mt-3">
                    <div className="flex flex-wrap items-center gap-2 text-xs text-gray-400">
                      <activeProject.icon className="w-4 h-4" />
                      <span>{activeProject.type}</span>
                      {activeProject.year && (
                        <>
                          <span>•</span>
                          <span>{activeProject.year}</span>
                        </>
                      )}
                    </div>

                    <button
                      type="button"
                      onClick={stopExternalPlayers}
                      className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-semibold text-black shadow-lg shadow-black/30 hover:bg-gray-200 transition"
                      aria-label="Arrêter la lecture Spotify ou vidéo"
                      title="Stop"
                    >
                      <span className="inline-block w-2.5 h-2.5 rounded-[2px] bg-black" />
                      Stop
                    </button>
                  </div>

                  {activeProject.description && (
                    <p className="text-sm text-gray-300 mt-3">
                      {activeProject.description}
                    </p>
                  )}

                  {activeProject.smartlink && (
                    <div className="flex justify-center mt-4">
                      <a
                        href={activeProject.smartlink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center rounded-full border border-white/30 bg-white/5 px-4 py-2 text-xs font-medium text-white hover:bg-white/10 transition"
                      >
                        Écouter sur toutes les plateformes
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            data-page-swipe-lock="true"
            className="hidden lg:block max-w-6xl mx-auto"
            onTouchStart={handleAlbumTouchStart}
            onTouchEnd={handleAlbumTouchEnd}
            onWheel={handleAlbumWheel}
          >
            <div className="grid grid-cols-1 lg:grid-cols-[minmax(280px,420px)_1fr] gap-7 lg:gap-12 items-center mb-8 md:mb-10">
              <div className="hidden lg:block relative mx-auto w-full max-w-[420px]">
                <div className="aspect-square rounded-2xl overflow-hidden bg-zinc-950 shadow-2xl shadow-black/50">
                  {activeProject.image && activeProject.image !== "/images/" ? (
                    <img
                      src={activeProject.image}
                      alt={projectLabel(activeProject)}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-zinc-950 to-pink-950/30 px-6 text-center">
                      <Music className="w-12 h-12 text-pink-400 mb-4" />
                      <span className="text-white text-lg font-bold tracking-wide">{projectLabel(activeProject)}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="min-w-0">
                {/* Tous les players restent montés : logique audio inchangée. */}
                <div className="relative rounded-xl overflow-hidden bg-zinc-950">
                  {projects.map((project, index) => {
                    const ytSrc = project.youtubeUrl ? ytWithApi(project.youtubeUrl) : null;
                    const visible = index === activeIndex;
                    return (
                      <div key={`player-${project.id}`} style={{ display: visible ? "block" : "none" }} aria-hidden={!visible}>
                        {project.spotifyUrl && (
                          <>
                            {spotifyApiLoaded ? (
                              <div id={`spotify-embed-${project.id}`} className="w-full h-[280px] sm:h-[320px] md:h-[352px]" />
                            ) : (
                              <iframe
                                src={project.spotifyUrl}
                                width="100%"
                                height="352"
                                frameBorder="0"
                                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                loading="lazy"
                                title={projectLabel(project)}
                                className="w-full h-[280px] sm:h-[320px] md:h-[352px]"
                              />
                            )}
                          </>
                        )}

                        {ytSrc && (
                          <div onPointerDownCapture={handleYouTubePointerDownCapture}>
                            <iframe
                              id={`yt-embed-${project.id}`}
                              src={ytSrc}
                              className="w-full h-[280px] sm:h-[320px] md:h-[352px]"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              title={`${projectLabel(project)} - YouTube`}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                <div className="mt-4 md:mt-5">
                  <div className="flex flex-wrap items-center gap-2 md:gap-3 text-xs sm:text-sm md:text-base text-gray-400">
                    <activeProject.icon className="w-4 h-4 md:w-5 md:h-5" />
                    <span>{activeProject.type}</span>
                    {activeProject.year && (
                      <>
                        <span>•</span>
                        <span>{activeProject.year}</span>
                      </>
                    )}
                    <button
                      type="button"
                      onClick={stopExternalPlayers}
                      className="ml-1 md:ml-2 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs md:text-sm font-semibold text-black shadow-lg shadow-black/30 hover:bg-gray-200 transition"
                      aria-label="Arrêter la lecture Spotify ou vidéo"
                      title="Stop"
                    >
                      <span className="inline-block w-2.5 h-2.5 rounded-[2px] bg-black" />
                      Stop
                    </button>
                  </div>
                  {activeProject.description && (
                    <p className="text-sm md:text-base text-gray-300 mt-3">
                      {activeProject.description}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Mobile : toutes les pochettes visibles dans une mosaïque adaptative */}
            <div className="lg:hidden mb-7">
              <div
                className="grid gap-3 sm:gap-4"
                style={{
                  gridTemplateColumns: "repeat(auto-fit, minmax(92px, 1fr))",
                }}
              >
                {projects.map((project, index) => (
                  <button
                    key={`mobile-${project.id}`}
                    type="button"
                    onClick={() => setActiveIndex(index)}
                    className={`rounded-xl overflow-hidden transition-all duration-300 ${
                      index === activeIndex
                        ? "scale-[1.04] opacity-100 ring-2 ring-white/80"
                        : "opacity-65"
                    }`}
                    aria-label={`Ouvrir ${projectLabel(project)}`}
                  >
                    <div className="aspect-square bg-zinc-950 flex items-center justify-center overflow-hidden">
                      {project.image && project.image !== "/images/" ? (
                        <img
                          src={project.image}
                          alt={projectLabel(project)}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-zinc-950 to-pink-950/30">
                          <Music className="w-8 h-8 text-pink-400" />
                        </div>
                      )}
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Rail de pochettes */}
            <div className="hidden lg:block relative px-10 md:px-14">
              <button
                type="button"
                onClick={() => goToAlbum(-1)}
                className="absolute left-0 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-10 md:h-10 rounded-full bg-black/80 text-white/75 flex items-center justify-center hover:bg-white/10 hover:text-white transition"
                aria-label="Album précédent"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>

              <div
                className="album-carousel-track flex gap-3 md:gap-4 overflow-x-hidden snap-x snap-mandatory py-3"
                style={{ scrollBehavior: "smooth", touchAction: "pan-y", scrollbarWidth: "none", msOverflowStyle: "none" }}
              >
                {projects.map((project, index) => (
                  <button
                    key={project.id}
                    ref={(el) => (cardRefs.current[index] = el)}
                    type="button"
                    onClick={() => setActiveIndex(index)}
                    className={`shrink-0 snap-center w-[82px] sm:w-[96px] md:w-[112px] rounded-xl overflow-hidden transition-all duration-300 ${index === activeIndex ? "scale-[1.08] opacity-100 ring-2 ring-white/80" : "opacity-50 hover:opacity-85"}`}
                    aria-label={`Ouvrir ${projectLabel(project)}`}
                  >
                    <div className="aspect-square bg-zinc-950 flex items-center justify-center overflow-hidden">
                      {project.image && project.image !== "/images/" ? (
                        <img src={project.image} alt={projectLabel(project)} className="w-full h-full object-cover" />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-zinc-950 to-pink-950/30">
                          <Music className="w-7 h-7 text-pink-400" />
                        </div>
                      )}
                    </div>
                  </button>
                ))}
              </div>

              <button
                type="button"
                onClick={() => goToAlbum(1)}
                className="absolute right-0 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-10 md:h-10 rounded-full bg-black/80 text-white/75 flex items-center justify-center hover:bg-white/10 hover:text-white transition"
                aria-label="Album suivant"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>

            <div className="flex justify-center mt-4">
              <div className="relative w-[78px] md:w-[110px] h-[3px] rounded-full bg-white/15 overflow-hidden">
                <div
                  className="absolute top-0 left-0 h-full rounded-full bg-pink-400 transition-all duration-300 ease-out"
                  style={{
                    width: `${100 / projects.length}%`,
                    transform: `translateX(${activeIndex * 100}%)`,
                  }}
                />
              </div>
            </div>

            {activeProject.smartlink && (
              <div className="flex justify-center mt-5">
                <a
                  href={activeProject.smartlink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center rounded-full border border-white/30 bg-white/5 px-4 py-2 text-xs font-medium text-white hover:bg-white/10 transition"
                >
                  Écouter sur toutes les plateformes
                </a>
              </div>
            )}
          </div>
          </div>
      </motion.div>
    </>
  );
};

export default Musique;